import { Contact } from '@/controllers/ShippingAddress';
import { selectRequestStatus } from '@/store/reducers/api-requests/selectors';
import { selectNewOpportunity } from '@/store/reducers/opportunities/selectors';
import { AppState, ContactVm } from '@/types';

export const selectHomeOwnerAddress = (state: AppState): ContactVm | null => {
  const opportunity = selectNewOpportunity(state);

  if (!opportunity) {
    return null;
  }

  return {
    ...opportunity.contact,
    eligibleEdit: false,
    isDefault: false,
  };
};

// TODO: get rid of old contact models and types
export const selectShippingAddresses = (state: AppState): Contact[] => {
  return state.shippingAddresses.oldContacts;
};

export const selectNewShippingAddresses = (state: AppState): ContactVm[] => {
  return state.shippingAddresses.newContacts ?? [];
};

export const selectProfileSavedAddressesReadyToBeShown = (state: AppState): boolean =>
  !(
    selectRequestStatus(state, 'shippingAddresses|fetchShippingAddresses') ||
    selectRequestStatus(state, 'shippingAddresses|updateShippingAddress') ||
    selectRequestStatus(state, 'shippingAddresses|createNewShippingAddress') ||
    selectRequestStatus(state, 'shippingAddresses|deleteShippingAddress') ||
    selectRequestStatus(state, 'dictionaries|fetchDeliveryTypes')
  );
